import { render, staticRenderFns } from "./AddFlat.vue?vue&type=template&id=5978d5bb&scoped=true&"
import script from "./AddFlat.vue?vue&type=script&lang=js&"
export * from "./AddFlat.vue?vue&type=script&lang=js&"
import style0 from "./AddFlat.vue?vue&type=style&index=0&id=5978d5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978d5bb",
  null
  
)

export default component.exports